import { render, staticRenderFns } from "./ReportsMedicalUnit.vue?vue&type=template&id=1cc1ffb4&scoped=true"
import script from "./ReportsMedicalUnit.vue?vue&type=script&lang=js"
export * from "./ReportsMedicalUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc1ffb4",
  null
  
)

export default component.exports